import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import PageLayout from "components/layout/PageLayout";
import { Loading } from "components/StatusScreen";
import ClassCard from "features/classes/ClassCard";
import { TABS, emptyMessage, filterJoined, sortJoined } from "features/classes/filters";
import { coursesApi } from "api";
import { FRONT_URL } from "lib/config";
import { statusCourses, fetchCourses, messageCourse } from "store/actions/courses";
import Button from "components/ui/Button";

function SearchIcon() {
  return (
    <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
      <circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M13 13l4.5 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

// "My classes": grey band with the title, search and status tabs, then a
// grid of joined classes with progress.
export default function MyClass() {
  const dispatch = useDispatch();
  const COURSES = useSelector((state) => state.courses);
  const [tab, setTab] = useState("all");
  const [query, setQuery] = useState("");

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(statusCourses("loading"));
    coursesApi
      .mine()
      .then((res) => dispatch(fetchCourses(res.data)))
      .catch((err) => dispatch(messageCourse(err?.response?.data?.message ?? "error")));
  }, [dispatch]);

  const items = sortJoined(COURSES.data);
  const list = filterJoined(items, tab, query);
  const [emptyTitle, emptyText] = emptyMessage(items, tab, query);

  return (
    <PageLayout className="yc-classes">
      <section className="yc-classes-band">
        <div className="yc-container yc-classes-container">
          <div className="yc-classes-band-top">
            <h1 className="yc-classes-title">My classes</h1>
            <label className="yc-classes-search">
              <SearchIcon />
              <input type="search" placeholder="Search my classes" aria-label="Search my classes" value={query} onChange={(e) => setQuery(e.target.value)} />
            </label>
          </div>
          <div className="yc-classes-tabs" role="tablist">
            {TABS.map(([key, name]) => (
              <button key={key} type="button" role="tab" aria-selected={tab === key} className={tab === key ? "is-active" : ""} onClick={() => setTab(key)}>
                {name}
              </button>
            ))}
          </div>
        </div>
      </section>

      <div className="yc-container yc-classes-container yc-classes-body">
        {COURSES.status === "loading" && <Loading />}
        {COURSES.status === "error" && <p>{COURSES.message}</p>}
        {COURSES.status === "ok" &&
          (list.length ? (
            <div className="yc-classes-grid">
              {list.map((item) => (
                <ClassCard key={item.course_id} item={item} />
              ))}
            </div>
          ) : (
            <div className="yc-classes-empty">
              <h2>{emptyTitle}</h2>
              <p>{emptyText}</p>
              {!query.trim() && tab !== "completed" && (
                <Button href={`${FRONT_URL}/courses`} size="lg">
                  Browse classes
                </Button>
              )}
            </div>
          ))}
      </div>
    </PageLayout>
  );
}
